<template>
  <div id="pageRoot" class="blind">

    <span class="pageInstruction" style="left: 55px; top: 55px;">
      <p>Escucha cada palabra.</p>
    </span>
    <span class="pageInstruction" style="left: 55px; top: 95px;">
      <p>Marca cada sílaba con un golpe.</p>
    </span>
    <span class="pageInstruction" style="left: 55px; top: 135px;">
      <p>Pinta tantos círculos como<br>sílabas tiene la palabra.</p>
    </span>

    <div class="textBubble" style="width:380px; height: 200px; left: 620px; top: 20px; border-radius: 5px;">
      <div class="textContainer textBase center" style="width: 90%; height: 90%;">
          <p class="center" style="font-size: 30px">Luego, en cada cartel, escribe otra palabra que tenga la misma cantidad de sílabas.</p>
      </div>
    </div>

    <img
    style="width: 170px; top: 260px; left: 70px"
    class="pageElement basicItem01"
    src="/pages/img/sordo/svgPage63Dog.svg"
    />

    <p class="textBase" style="top: 390px; left: 90px;">PERRO</p>

    <label
      class="checkMarkContainer-blind"
      style="left: 294px; top: 322px; font-size: 0px"
      >Una Sílaba
      <input type="checkbox"
        />
      <span class="checkmark-blind"></span>
    </label>
    <label
      class="checkMarkContainer-blind"
      style="left: 357px; top: 322px; font-size: 0px"
      >Dos Sílabas
      <input type="checkbox"
        />
      <span class="checkmark-blind"></span>
    </label>
    <label
      class="checkMarkContainer-blind"
      style="left: 421px; top: 322px; font-size: 0px"
      >Tres Sílabas
      <input type="checkbox"
        />
      <span class="checkmark-blind"></span>
    </label>
    <label
      class="checkMarkContainer-blind"
      style="left: 483px; top: 322px; font-size: 0px"
      >Cuatro Sílabas
      <input type="checkbox"
      disabled 
        />
      <span class="checkmark-blind"></span>
    </label>
    <label
      class="checkMarkContainer-blind"
      style="left: 546px; top: 322px; font-size: 0px"
      >Cinco Sílabas
      <input type="checkbox"
      disabled 
        />
      <span class="checkmark-blind"></span>
    </label>
    <label
      class="checkMarkContainer-blind"
      style="left: 610px; top: 322px; font-size: 0px"
      >Seis Sílabas
      <input type="checkbox"
      disabled 
        />
      <span class="checkmark-blind"></span>
    </label>

    <div style="width: 230px; height: 200px; top: 280px; left: 730px; position: absolute;">
    <saved-input-narrator-friendly
      v-bind:page="$parent.page"
      v-bind:type="$parent.type"
      number="0"
      id="inputField01"
      class="centerH"
      style="position: absolute;
      width: 160px;
      height: 50px;
      top: 50px;
      z-index: 2"
    />
    <img
    style="width: 100%; z-index: -1"
    class="pageElement"
    src="/pages/img/general/blindNote.svg"
    />
    </div>

    <img
    style="width: 170px; top: 500px; left: 70px"
    class="pageElement basicItem01"
    src="/pages/img/sordo/svgPage64Butterfly.svg"
    />

    <p class="textBase" style="top: 690px; left: 40px;">MARIPOSA</p>

    <label
      class="checkMarkContainer-blind"
      style="left: 294px; top: 573px; font-size: 0px"
      >Una Sílaba
      <input type="checkbox"
        ref="b1" 
        v-on:change="saveOption('radios', 'b1')" 
        :onload="loadOption('radios', 'b1')"
        />
      <span class="checkmark-blind"></span>
    </label>
    <label
      class="checkMarkContainer-blind"
      style="left: 357px; top: 573px; font-size: 0px"
      >Dos Sílabas
      <input type="checkbox"
        ref="b2" 
        v-on:change="saveOption('radios', 'b2')" 
        :onload="loadOption('radios', 'b2')"
        />
      <span class="checkmark-blind"></span>
    </label>
    <label
      class="checkMarkContainer-blind"
      style="left: 421px; top: 573px; font-size: 0px"
      >Tres Sílabas
      <input type="checkbox"
        ref="b3" 
        v-on:change="saveOption('radios', 'b3')" 
        :onload="loadOption('radios', 'b3')"
        />
      <span class="checkmark-blind"></span>
    </label>
    <label
      class="checkMarkContainer-blind"
      style="left: 483px; top: 573px; font-size: 0px"
      >Cuatro Sílabas
      <input type="checkbox"
        ref="b4" 
        v-on:change="saveOption('radios', 'b4')" 
        :onload="loadOption('radios', 'b4')"
        />
      <span class="checkmark-blind"></span>
    </label>
    <label
      class="checkMarkContainer-blind"
      style="left: 546px; top: 573px; font-size: 0px"
      >Cinco Sílabas
      <input type="checkbox"
        ref="b5" 
        v-on:change="saveOption('radios', 'b5')" 
        :onload="loadOption('radios', 'b5')"
        />
      <span class="checkmark-blind"></span>
    </label>
    <label
      class="checkMarkContainer-blind"
      style="left: 610px; top: 573px; font-size: 0px"
      >Seis Sílabas
      <input type="checkbox"
        ref="b6" 
        v-on:change="saveOption('radios', 'b6')" 
        :onload="loadOption('radios', 'b6')"
        />
      <span class="checkmark-blind"></span>
    </label>

  <div style="width: 230px; height: 200px; top: 530px; left: 730px; position: absolute;">
    <saved-input-narrator-friendly
      v-bind:page="$parent.page"
      v-bind:type="$parent.type"
      number="1"
      id="inputField01"
      class="centerH"
      style="position: absolute;
      width: 160px;
      height: 50px;
      top: 50px;
      z-index: 2"
    />
    <img
    style="width: 100%; z-index: -1"
    class="pageElement"
    src="/pages/img/general/blindNote.svg"
    />
  </div>
    
  </div>
</template>
<script>
  export default {
    methods:{
      dbId(name, option){
        return `${this.$parent.pageID()}-${name}-${option}`
      },
      async loadOption(name, option) {
        var id = this.dbId(name, option);

        var value = await this.$db.options.get({
        id: id,
        }).catch(function(error){
        console.log("error getting option" + error);
        });
        if (value === undefined) return;
        console.log(value);

        this.$refs[option].checked=value.option;

        console.log("option loaded: " + id + ", " + value.option);
      },
      saveOption(name, option) {
        var id = this.dbId(name, option);
        var value = this.$refs[option].checked;

        this.$db.options.put({
              id: id,
              option: value
          }).catch(function(error){
              console.log("error saving option" + error);
          });

        console.log("option saved: " + id + ", " + value);
      }
    },
    mounted(){

    }
  }
</script>